import Swiper, { Pagination, Autoplay } from 'swiper';
import { $Q } from '../utils/querySelector';
import 'swiper/css';
import { mediaQuery } from '../utils/mediaQuery';

class PhotographerGallery {
  constructor() {
    this.photographerGallery = $Q('.photographer-gallery');

    this.photographerGallery && this._init();
  }
  /**
   * Initialize PhotographerGallery feature
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */

  _init() {
    mediaQuery(
      '(max-width: 991px)',
      this._initPhotographerGallerySlider.bind(this)
    );
  }

  /**
   * Initialize PhotographerGallery slider with swiper slider
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _initPhotographerGallerySlider() {
    this.slide = new Swiper('.photographer-gallery__slider', {
      modules: [Pagination],
      slidesPerView: 2,
      spaceBetween: 16,
      pagination: {
        el: '.swiper-custom-pagination',
        clickable: true,
      },
    });
  }
}

export { PhotographerGallery };
